export default __webpack_public_path__ + "static/media/branch-icon-gray.851a6388.svg";